<div class="logements-page">
  <a
    [routerLink]="routes.logements"
    class="logements-back"
    [title]="'common.backToList' | translate"
    [attr.aria-label]="'common.backToList' | translate"
    >
    <fa-icon icon="arrow-left"></fa-icon>
  </a>

  @if (loading) {
    <p class="logements-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="logements-status logements-status--error">
      {{ 'logements.fiche.notFound' | translate }}
    </p>
  }

  @if (!loading && !error && bien; as current) {
    @if (!editingBien) {
      <header class="logements-header">
        <div class="logements-header-row">
          <div class="logements-header-main">
            <h2 class="logements-title">{{ current.titreDto }}</h2>
            @if (adresse) {
              <p class="logements-subtitle">{{ adresse }}</p>
            }
            <p class="logements-subtitle">{{ unites }}</p>
          </div>
          <div class="logements-header-actions">
            <button
              type="button"
              class="logements-row-action"
              [title]="'logements.fiche.editBien' | translate"
              [attr.aria-label]="'logements.fiche.editBien' | translate"
              [disabled]="isBusy || isEditing"
              (click)="startEditBien()"
              >
              <fa-icon icon="pen"></fa-icon>
            </button>
            <button
              type="button"
              class="logements-row-action logements-row-action--danger"
              [title]="'logements.fiche.deleteBien' | translate"
              [attr.aria-label]="'logements.fiche.deleteBien' | translate"
              [disabled]="isBusy || isEditing"
              (click)="askDeleteBien()"
              >
              <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
            </button>
          </div>
        </div>
      </header>
    }
    @if (editingBien) {
      <section class="logements-section">
        <div class="logements-bien-edit">
          <h3>{{ 'logements.fiche.editBien' | translate }}</h3>
          <form
            class="logements-form"
            (ngSubmit)="submitBien()"
            [formGroup]="bienForm"
            >
            <label [class.is-invalid]="showBienError('titre')">
              {{ 'logements.ajout.titre' | translate }}
              <input type="text" formControlName="titre" autocomplete="off" />
              @if (showBienError('titre')) {
                <span class="logements-field-error">
                  {{ 'logements.fiche.titreRequired' | translate }}
                </span>
              }
            </label>
            <label [class.is-invalid]="showBienError('rue')">
              {{ 'logements.ajout.rue' | translate }}
              <input
                type="text"
                formControlName="rue"
                autocomplete="address-line1"
                />
                @if (showBienError('rue')) {
                  <span class="logements-field-error">
                    {{ 'logements.fiche.rueRequired' | translate }}
                  </span>
                }
              </label>
              <div class="logements-form-row">
                <label [class.is-invalid]="showBienError('codePostal')">
                  {{ 'logements.ajout.codePostal' | translate }}
                  <input
                    type="text"
                    formControlName="codePostal"
                    autocomplete="postal-code"
                    />
                    @if (showBienError('codePostal')) {
                      <span
                        class="logements-field-error"
                        >
                        {{ 'logements.fiche.codePostalRequired' | translate }}
                      </span>
                    }
                  </label>
                  <label [class.is-invalid]="showBienError('ville')">
                    {{ 'logements.ajout.ville' | translate }}
                    <input
                      type="text"
                      formControlName="ville"
                      autocomplete="address-level2"
                      />
                      @if (showBienError('ville')) {
                        <span class="logements-field-error">
                          {{ 'logements.fiche.villeRequired' | translate }}
                        </span>
                      }
                    </label>
                  </div>
                  <label>
                    {{ 'logements.ajout.complement' | translate }}
                    <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                    <input
                      type="text"
                      formControlName="complement"
                      autocomplete="address-line2"
                      />
                    </label>
                    @if (bienFormError) {
                      <p
                        class="logements-status logements-status--error"
                        >
                        {{ 'logements.fiche.saveBienError' | translate }}
                      </p>
                    }
                    <div class="logements-form-actions">
                      <button
                        type="button"
                        class="logements-cancel"
                        [disabled]="isBusy"
                        (click)="cancelEditBien()"
                        >
                        {{ 'common.cancel' | translate }}
                      </button>
                      <button
                        type="submit"
                        class="logements-action-btn"
                        [disabled]="isBusy"
                        >
                        {{
                        saving
                        ? ('common.saving' | translate)
                        : ('common.save' | translate)
                        }}
                      </button>
                    </div>
                  </form>
                </div>
              </section>
            }
            @if (!editingBien) {
              <section class="logements-section">
                <div class="logements-panels">
                  <div class="logements-panel">
                    <button
                      type="button"
                      class="logements-panel-toggle"
                      [attr.aria-expanded]="isSectionOpen('achat')"
                      [disabled]="isBusy"
                      (click)="toggleSection('achat')"
                      >
                      <span>{{ 'logements.fiche.sectionAchat' | translate }}</span>
                      <fa-icon
                        icon="chevron-down"
                        [class.is-open]="isSectionOpen('achat')"
                      ></fa-icon>
                    </button>
                    @if (isSectionOpen('achat')) {
                      <div class="logements-panel-body">
                        <form
                          class="logements-form"
                          (ngSubmit)="submitSection('achat')"
                          [formGroup]="achatForm"
                          >
                          <div class="logements-form-row">
                            <label>
                              {{ 'logements.fiche.dateAchat' | translate }}
                              <input type="date" formControlName="dateAchat" />
                            </label>
                            <label>
                              {{ 'logements.fiche.dateVente' | translate }}
                              <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                              <input type="date" formControlName="dateVente" />
                            </label>
                          </div>
                          <label>
                            {{ 'logements.fiche.prixAchat' | translate }}
                            <input type="number" min="0" step="1" formControlName="prix" />
                          </label>
                          <div class="logements-form-row">
                            <label>
                              {{ 'logements.fiche.fraisNotaire' | translate }}
                              <input
                                type="number"
                                min="0"
                                step="1"
                                formControlName="fraisNotaire"
                                />
                              </label>
                              <label>
                                {{ 'logements.fiche.fraisAgence' | translate }}
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  formControlName="fraisAgence"
                                  />
                                </label>
                              </div>
                              <div class="logements-form-row">
                                <label>
                                  {{ 'logements.fiche.fraisDossier' | translate }}
                                  <input
                                    type="number"
                                    min="0"
                                    step="1"
                                    formControlName="fraisDossier"
                                    />
                                  </label>
                                  <label>
                                    {{ 'logements.fiche.caution' | translate }}
                                    <input
                                      type="number"
                                      min="0"
                                      step="1"
                                      formControlName="fraisCaution"
                                      />
                                    </label>
                                  </div>
                                  @if (showSectionError('achat')) {
                                    <p
                                      class="logements-status logements-status--error"
                                      >
                                      {{ 'logements.fiche.sectionSaveError' | translate }}
                                    </p>
                                  }
                                  <div class="logements-form-actions">
                                    <button
                                      type="submit"
                                      class="logements-action-btn"
                                      [disabled]="isBusy"
                                      >
                                      {{ sectionSaveLabel('achat') }}
                                    </button>
                                  </div>
                                </form>
                                @if (current.idBienDto; as idBien) {
                                  <app-documents-achat [bienId]="idBien" />
                                }
                              </div>
                            }
                          </div>
                          <div class="logements-panel">
                            <button
                              type="button"
                              class="logements-panel-toggle"
                              [attr.aria-expanded]="isSectionOpen('encadrement')"
                              [disabled]="isBusy"
                              (click)="toggleSection('encadrement')"
                              >
                              <span>{{ 'logements.fiche.sectionEncadrement' | translate }}</span>
                              <fa-icon
                                icon="chevron-down"
                                [class.is-open]="isSectionOpen('encadrement')"
                              ></fa-icon>
                            </button>
                            @if (isSectionOpen('encadrement')) {
                              <form
                                class="logements-form logements-panel-body"
                                (ngSubmit)="submitSection('encadrement')"
                                [formGroup]="encadrementForm"
                                >
                                <label class="logements-check">
                                  <input type="checkbox" formControlName="zoneTendue" />
                                  {{ 'logements.fiche.zoneTendue' | translate }}
                                </label>
                                <label class="logements-check">
                                  <input type="checkbox" formControlName="evolutionMaxLoyer" />
                                  {{ 'logements.fiche.evolutionMaxLoyer' | translate }}
                                </label>
                                <label class="logements-check">
                                  <input type="checkbox" formControlName="loyerPlafonemment" />
                                  {{ 'logements.fiche.loyerPlafonne' | translate }}
                                </label>
                                @if (encadrementForm.controls.loyerPlafonemment.value) {
                                  <div class="logements-form-row">
                                    <label [class.is-invalid]="showEncadrementError('loyerReference')">
                                      {{ 'logements.fiche.loyerReference' | translate }}
                                      <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        formControlName="loyerReference"
                                        />
                                        @if (showEncadrementError('loyerReference')) {
                                          <span
                                            class="logements-field-error"
                                            >
                                            {{ 'logements.fiche.loyerReferenceRequired' | translate }}
                                          </span>
                                        }
                                      </label>
                                      <label [class.is-invalid]="showEncadrementError('loyerMajore')">
                                        {{ 'logements.fiche.loyerMajore' | translate }}
                                        <input
                                          type="number"
                                          min="0"
                                          step="1"
                                          formControlName="loyerMajore"
                                          />
                                          @if (showEncadrementError('loyerMajore')) {
                                            <span
                                              class="logements-field-error"
                                              >
                                              {{ 'logements.fiche.loyerMajoreRequired' | translate }}
                                            </span>
                                          }
                                        </label>
                                      </div>
                                      <label>
                                        {{ 'logements.fiche.complementLoyer' | translate }}
                                        <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                        <input type="text" formControlName="complementLoyer" />
                                      </label>
                                    }
                                    @if (showSectionError('encadrement')) {
                                      <p
                                        class="logements-status logements-status--error"
                                        >
                                        {{ 'logements.fiche.sectionSaveError' | translate }}
                                      </p>
                                    }
                                    <div class="logements-form-actions">
                                      <button
                                        type="submit"
                                        class="logements-action-btn"
                                        [disabled]="isBusy"
                                        >
                                        {{ sectionSaveLabel('encadrement') }}
                                      </button>
                                    </div>
                                  </form>
                                }
                              </div>
                              <div class="logements-panel">
                                <button
                                  type="button"
                                  class="logements-panel-toggle"
                                  [attr.aria-expanded]="isSectionOpen('communes')"
                                  [disabled]="isBusy"
                                  (click)="toggleSection('communes')"
                                  >
                                  <span>{{ 'logements.fiche.sectionCaracteristiques' | translate }}</span>
                                  <fa-icon
                                    icon="chevron-down"
                                    [class.is-open]="isSectionOpen('communes')"
                                  ></fa-icon>
                                </button>
                                @if (isSectionOpen('communes')) {
                                  <form
                                    class="logements-form logements-panel-body"
                                    (ngSubmit)="submitSection('communes')"
                                    [formGroup]="communesForm"
                                    >
                                    <div class="logements-form-row">
                                      <label>
                                        {{ 'logements.fiche.typeHabitat' | translate }}
                                        <select formControlName="typeHabitat">
                                          <option value="">{{ 'common.choose' | translate }}</option>
                                          @if (extraTypeHabitat) {
                                            <option [value]="extraTypeHabitat">
                                              {{ extraTypeHabitat | i18nValue: 'ref.typeHabitat' }}
                                            </option>
                                          }
                                          @for (type of typesHabitat; track type) {
                                            <option [value]="type">
                                              {{ type | i18nValue: 'ref.typeHabitat' }}
                                            </option>
                                          }
                                        </select>
                                      </label>
                                      <label>
                                        {{ 'logements.fiche.regimeJuridique' | translate }}
                                        <select formControlName="regime">
                                          <option value="">{{ 'common.choose' | translate }}</option>
                                          @if (extraRegime) {
                                            <option [value]="extraRegime">
                                              {{ extraRegime | i18nValue: 'ref.regime' }}
                                            </option>
                                          }
                                          @for (regime of regimesJuridiques; track regime) {
                                            <option
                                              [value]="regime"
                                              >
                                              {{ regime | i18nValue: 'ref.regime' }}
                                            </option>
                                          }
                                        </select>
                                      </label>
                                    </div>
                                    <div class="logements-form-row">
                                      <label>
                                        {{ 'logements.fiche.periodeConstruction' | translate }}
                                        <select formControlName="periode">
                                          <option value="">{{ 'common.choose' | translate }}</option>
                                          @if (extraPeriode) {
                                            <option [value]="extraPeriode">
                                              {{ extraPeriode | i18nValue: 'ref.periode' }}
                                            </option>
                                          }
                                          @for (periode of periodesConstruction; track periode) {
                                            <option
                                              [value]="periode"
                                              >
                                              {{ periode | i18nValue: 'ref.periode' }}
                                            </option>
                                          }
                                        </select>
                                      </label>
                                      <label>
                                        {{ 'logements.fiche.anneeConstruction' | translate }}
                                        <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                        <input
                                          type="number"
                                          min="1000"
                                          max="9999"
                                          step="1"
                                          formControlName="anneeConstruction"
                                          />
                                        </label>
                                      </div>
                                      <label>
                                        {{ 'logements.fiche.usage' | translate }}
                                        <select formControlName="usage">
                                          <option value="">{{ 'common.choose' | translate }}</option>
                                          @if (extraUsage) {
                                            <option [value]="extraUsage">
                                              {{ extraUsage | i18nValue: 'ref.usage' }}
                                            </option>
                                          }
                                          @for (usage of usagesBien; track usage) {
                                            <option [value]="usage">
                                              {{ usage | i18nValue: 'ref.usage' }}
                                            </option>
                                          }
                                        </select>
                                      </label>
                                    <label>
                                      {{ 'logements.fiche.partiesCommunes' | translate }}
                                      <textarea
                                        rows="3"
                                        formControlName="partiesCommunes"
                                      ></textarea>
                                    </label>
                                    <label>
                                      {{ 'logements.fiche.equipementsCommuns' | translate }}
                                      <textarea
                                        rows="3"
                                        formControlName="equipementsComm"
                                      ></textarea>
                                    </label>
                                    @if (showSectionError('communes')) {
                                      <p
                                        class="logements-status logements-status--error"
                                        >
                                        {{ 'logements.fiche.sectionSaveError' | translate }}
                                      </p>
                                    }
                                    <div class="logements-form-actions">
                                      <button
                                        type="submit"
                                        class="logements-action-btn"
                                        [disabled]="isBusy"
                                        >
                                        {{ sectionSaveLabel('communes') }}
                                      </button>
                                    </div>
                                  </form>
                                }
                              </div>
                              <div class="logements-panel">
                                <button
                                  type="button"
                                  class="logements-panel-toggle"
                                  [attr.aria-expanded]="isSectionOpen('unites')"
                                  [disabled]="isBusy"
                                  (click)="toggleSection('unites')"
                                  >
                                  <span>{{ unitesPanelTitle }}</span>
                                  <fa-icon
                                    icon="chevron-down"
                                    [class.is-open]="isSectionOpen('unites')"
                                  ></fa-icon>
                                </button>
                                @if (isSectionOpen('unites')) {
                                  <div class="logements-panel-body">
                                    <div class="logements-switch-row">
                                      <div class="logements-switch-copy">
                                        <span class="logements-switch-label">
                                          {{
                                            'logements.fiche.loueEnEntier'
                                              | translate
                                          }}
                                          <app-help-tip
                                            [textKey]="loueEnEntierHelpKey"
                                          />
                                        </span>
                                      </div>
                                      <label
                                        class="logements-switch"
                                        [class.is-on]="loueEnEntierDraft"
                                        [class.is-disabled]="!canToggleLoueEnEntier"
                                        >
                                        <input
                                          type="checkbox"
                                          role="switch"
                                          class="logements-switch-input"
                                          aria-checked="false"
                                          [attr.aria-checked]="loueEnEntierDraft ? 'true' : 'false'"
                                          [checked]="loueEnEntierDraft"
                                          [disabled]="!canToggleLoueEnEntier"
                                          [attr.aria-label]="'logements.fiche.loueEnEntier' | translate"
                                          (change)="onLoueEnEntierChange($event)"
                                          />
                                          <span class="logements-switch-knob" aria-hidden="true"></span>
                                        </label>
                                      </div>
                                      @if (loueEnEntierDirty) {
                                        <div
                                          class="logements-form-actions logements-switch-actions"
                                          >
                                          <button
                                            type="button"
                                            class="logements-cancel"
                                            [disabled]="isBusy"
                                            (click)="cancelLoueEnEntierDraft()"
                                            >
                                            {{ 'common.cancel' | translate }}
                                          </button>
                                          <button
                                            type="button"
                                            class="logements-action-btn"
                                            [disabled]="isBusy || isEditing || editingBien"
                                            (click)="saveLoueEnEntierMode()"
                                            >
                                            {{
                                            saving
                                            ? ('common.saving' | translate)
                                            : ('common.save' | translate)
                                            }}
                                          </button>
                                        </div>
                                      }
                                      @if (entierError) {
                                        <p
                                          class="logements-status logements-status--error"
                                          >
                                          {{ 'logements.fiche.loueEnEntierError' | translate }}
                                        </p>
                                      }
                                      @if (loueEnEntierDraft && unitesList.length === 0 && !loueEnEntierDirty) {
                                        <p
                                          class="logements-empty"
                                          >
                                          {{ 'logements.fiche.noLogementYet' | translate }}
                                        </p>
                                      }
                                      @if (loueEnEntierDraft && unitesList.length === 0 && loueEnEntierDirty) {
                                        <p
                                          class="logements-empty-hint"
                                          >
                                          {{ 'logements.fiche.saveToCreateUnique' | translate }}
                                        </p>
                                      }
                                      @if (!loueEnEntierDraft && unitesList.length === 0) {
                                        <p
                                          class="logements-empty"
                                          >
                                          {{ 'logements.fiche.noUniteYet' | translate }}
                                        </p>
                                      }
                                      @if (unitesList.length > 0) {
                                        <ul class="logements-list">
                                          @for (unite of unitesList; track unite) {
                                            <li
                                              class="logements-row"
                                              [class.logements-row--editing]="isEditingUnite(unite)"
                                              [class.logements-row--fermee]="isFermee(unite)"
                                              >
                                              @if (!isEditingUnite(unite)) {
                                                <div class="logements-row-main">
                                                  <h4 class="logements-row-title">
                                                    <span>
                                                      {{
                                                      loueEnEntierDraft
                                                      ? ('logements.fiche.bienLoueEnEntier' | translate)
                                                      : label(unite)
                                                      }}
                                                    </span>
                                                    @if (hasDossierStatus(unite)) {
                                                      <span
                                                        class="dossier-status"
                                                        [class.dossier-status--ok]="dossierComplet(unite)"
                                                        [class.dossier-status--ko]="!dossierComplet(unite)"
                                                        [title]="
                                                          (dossierComplet(unite)
                                                            ? 'dossierTechnique.statusComplet'
                                                            : 'dossierTechnique.statusIncomplet'
                                                          ) | translate
                                                        "
                                                        [attr.aria-label]="
                                                          (dossierComplet(unite)
                                                            ? 'dossierTechnique.statusComplet'
                                                            : 'dossierTechnique.statusIncomplet'
                                                          ) | translate
                                                        "
                                                      >
                                                        <fa-icon
                                                          [icon]="
                                                            dossierComplet(unite)
                                                              ? 'check'
                                                              : 'xmark'
                                                          "
                                                        ></fa-icon>
                                                      </span>
                                                    }
                                                  </h4>
                                                  @if (details(unite)) {
                                                    <p>{{ details(unite) }}</p>
                                                  }
                                                </div>
                                                <div class="logements-row-actions">
                                                  <button
                                                    type="button"
                                                    class="logements-row-action"
                                                    [title]="'dossierTechnique.open' | translate"
                                                    [attr.aria-label]="'dossierTechnique.open' | translate"
                                                    [disabled]="isBusy || isEditing || editingBien || loueEnEntierDirty"
                                                    (click)="openDossierTechnique(unite)"
                                                  >
                                                    <fa-icon icon="file-lines"></fa-icon>
                                                  </button>
                                                  @if (!isFermee(unite)) {
                                                    <button
                                                      type="button"
                                                      class="logements-row-action"
                                                      [title]="'common.edit' | translate"
                                                      [attr.aria-label]="'common.edit' | translate"
                                                      [disabled]="isBusy || isEditing || editingBien || loueEnEntierDirty"
                                                      (click)="startEdit(unite)"
                                                      >
                                                      <fa-icon icon="pen"></fa-icon>
                                                    </button>
                                                  }
                                                  @if (isFermee(unite)) {
                                                    <button
                                                      type="button"
                                                      class="logements-row-action"
                                                      [title]="'logements.fiche.reopenGestion' | translate"
                                                      [attr.aria-label]="'logements.fiche.reopenGestion' | translate"
                                                      [disabled]="isBusy || isEditing || editingBien || loueEnEntierDirty"
                                                      (click)="reopenUnite(unite)"
                                                      >
                                                      <fa-icon icon="door-open"></fa-icon>
                                                    </button>
                                                  }
                                                  @if (!loueEnEntierDraft) {
                                                    <button
                                                      type="button"
                                                      class="logements-row-action logements-row-action--danger"
                                                      [title]="'common.delete' | translate"
                                                      [attr.aria-label]="'common.delete' | translate"
                                                      [disabled]="isBusy || isEditing || editingBien || loueEnEntierDirty"
                                                      (click)="askDelete(unite)"
                                                      >
                                                      <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
                                                    </button>
                                                  }
                                                </div>
                                              }
                                              @if (isEditingUnite(unite)) {
                                                <form
                                                  class="logements-form"
                                                  (ngSubmit)="submit()"
                                                  [formGroup]="form"
                                                  >
                                                  @if (!loueEnEntier) {
                                                    <ng-container
                                                      *ngTemplateOutlet="
                                                        uniteTypeNumeroFields;
                                                        context: { includeExtraType: true }
                                                      "
                                                    />
                                                  }
                                                  <ng-container
                                                    *ngTemplateOutlet="uniteSurfacePiecesFields"
                                                  />
                                                        @if (isParking) {
                                                          <div class="logements-form-row">
                                                            <label>
                                                              {{ 'logements.fiche.parkingChauffe' | translate }}
                                                              <select formControlName="chauffage">
                                                                <option value="">{{ 'common.choose' | translate }}</option>
                                                                @for (opt of typesParkingChauffage; track opt) {
                                                                  <option [value]="opt">
                                                                    {{ opt | i18nValue: 'ref.chauffage' }}
                                                                  </option>
                                                                }
                                                              </select>
                                                            </label>
                                                          </div>
                                                        } @else {
                                                          <div class="logements-form-row">
                                                            <label>
                                                              {{ 'logements.fiche.chauffage' | translate }}
                                                              <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                              <select formControlName="chauffage">
                                                                <option value="">{{ 'common.choose' | translate }}</option>
                                                                @if (extraChauffage) {
                                                                  <option [value]="extraChauffage">
                                                                    {{ extraChauffage | i18nValue: 'ref.chauffage' }}
                                                                  </option>
                                                                }
                                                                @for (type of typesChauffage; track type) {
                                                                  <option
                                                                    [value]="type"
                                                                    >
                                                                    {{ type | i18nValue: 'ref.chauffage' }}
                                                                  </option>
                                                                }
                                                              </select>
                                                            </label>
                                                            <label>
                                                              {{ 'logements.fiche.eau' | translate }}
                                                              <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                              <select formControlName="eau">
                                                                <option value="">{{ 'common.choose' | translate }}</option>
                                                                @if (extraEau) {
                                                                  <option [value]="extraEau">
                                                                    {{ extraEau | i18nValue: 'ref.eau' }}
                                                                  </option>
                                                                }
                                                                @for (type of typesEau; track type) {
                                                                  <option [value]="type">
                                                                    {{ type | i18nValue: 'ref.eau' }}
                                                                  </option>
                                                                }
                                                              </select>
                                                            </label>
                                                          </div>
                                                        }
                                                        <label>
                                                          {{ 'logements.fiche.autresParties' | translate }}
                                                          <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                          <textarea
                                                            rows="2"
                                                            formControlName="autreParties"
                                                            [placeholder]="'logements.fiche.autresPartiesPlaceholder' | translate"
                                                          ></textarea>
                                                        </label>
                                                        @if (!isParking) {
                                                          <label>
                                                            {{ 'logements.fiche.modeOccupation' | translate }}
                                                            <select formControlName="meuble">
                                                              <option [ngValue]="false">
                                                                {{ 'logements.fiche.nonMeuble' | translate }}
                                                              </option>
                                                              <option [ngValue]="true">
                                                                {{ 'logements.fiche.meuble' | translate }}
                                                              </option>
                                                            </select>
                                                          </label>
                                                        }
                                                        <label>
                                                          {{ 'logements.fiche.statutFiscal' | translate }}
                                                          <select formControlName="statutFiscal">
                                                            <option value="">{{ 'common.chooseEllipsis' | translate }}</option>
                                                            @for (statut of typesStatutFiscal; track statut) {
                                                              <option
                                                                [value]="statut"
                                                                >
                                                                {{ statut | i18nValue: 'ref.statutFiscal' }}
                                                              </option>
                                                            }
                                                          </select>
                                                        </label>
                                                        <label>
                                                          {{ 'logements.fiche.finGestion' | translate }}
                                                          <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                          <input type="date" formControlName="dateFinGestion" />
                                                        </label>
                                                        @if (!isParking) {
                                                          <label class="logements-check">
                                                            <input type="checkbox" formControlName="colocation" />
                                                            {{ 'logements.fiche.colocation' | translate }}
                                                          </label>
                                                        }
                                                        @if (!isParking && form.controls.colocation.value) {
                                                          <label class="logements-check">
                                                            <input
                                                              type="checkbox"
                                                              formControlName="assuranceBailleur"
                                                              />
                                                              {{ 'logements.fiche.assuranceBailleur' | translate }}
                                                            </label>
                                                            @if (form.controls.assuranceBailleur.value) {
                                                              <div
                                                                class="logements-form-row"
                                                                >
                                                                <label>
                                                                  {{ 'logements.fiche.montantAnnuelAssurance' | translate }}
                                                                  <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                                  <input
                                                                    type="number"
                                                                    min="0"
                                                                    step="1"
                                                                    formControlName="montantAnnuelAssurance"
                                                                    />
                                                                  </label>
                                                                  <label>
                                                                    {{ 'logements.fiche.assuranceLocataireMensuelle' | translate }}
                                                                    <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                                    <input
                                                                      type="number"
                                                                      min="0"
                                                                      step="1"
                                                                      formControlName="montantMensuelAssuranceLocataire"
                                                                      />
                                                                    </label>
                                                                  </div>
                                                                }
                                                                <label>
                                                                  {{ 'logements.fiche.clauseSolidarite' | translate }}
                                                                  <span class="logements-optional">{{ 'common.optional' | translate }}</span>
                                                                  <textarea
                                                                    rows="2"
                                                                    formControlName="clauseSolidarite"
                                                                  ></textarea>
                                                                </label>
                                                              }
                                                              @if (formError) {
                                                                <p
                                                                  class="logements-status logements-status--error"
                                                                  >
                                                                  {{ saveErrorMessage | translate }}
                                                                </p>
                                                              }
                                                              <div class="logements-form-actions">
                                                                <button
                                                                  type="button"
                                                                  class="logements-cancel"
                                                                  [disabled]="isBusy"
                                                                  (click)="cancelEdit()"
                                                                  >
                                                                  {{ 'common.cancel' | translate }}
                                                                </button>
                                                                <button
                                                                  type="submit"
                                                                  class="logements-action-btn"
                                                                  [disabled]="isBusy"
                                                                  >
                                                                  {{ submitLabel }}
                                                                </button>
                                                              </div>
                                                            </form>
                                                          }
                                                        </li>
                                                      }
                                                    </ul>
                                                  }
                                                  @if (deleteError) {
                                                    <p class="logements-status logements-status--error">
                                                      {{ 'logements.fiche.deleteUniteError' | translate }}
                                                    </p>
                                                  }
                                                  @if (!loueEnEntierDraft && !isEditing && !loueEnEntierDirty) {
                                                    <div
                                                      class="logements-add logements-add--nested"
                                                      >
                                                      <h3>{{ 'logements.fiche.addUnite' | translate }}</h3>
                                                      <form
                                                        class="logements-form"
                                                        (ngSubmit)="submit()"
                                                        [formGroup]="form"
                                                        >
                                                        <ng-container
                                                          *ngTemplateOutlet="
                                                            uniteTypeNumeroFields;
                                                            context: { includeExtraType: false }
                                                          "
                                                        />
                                                        <ng-container
                                                          *ngTemplateOutlet="uniteSurfacePiecesFields"
                                                        />
                                                              @if (formError) {
                                                                <p
                                                                  class="logements-status logements-status--error"
                                                                  >
                                                                  {{ saveErrorMessage | translate }}
                                                                </p>
                                                              }
                                                              <div class="logements-form-actions">
                                                                <button
                                                                  type="submit"
                                                                  class="logements-action-btn"
                                                                  [disabled]="isBusy"
                                                                  >
                                                                  {{ submitLabel }}
                                                                </button>
                                                              </div>
                                                            </form>
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              </section>
                                            }
                                          }

                                          <dialog
                                            #bienDeleteDialog
                                            class="logements-dialog"
                                            aria-labelledby="delete-bien-title"
                                            (cancel)="onBienDeleteDialogCancel($event)"
                                            (click)="onDialogBackdropClick($event, 'bien')"
                                            (keydown)="onDialogBackdropKeydown($event, 'bien')"
                                            >
                                            @if (bien; as current) {
                                              <h3 id="delete-bien-title">
                                                {{ 'logements.fiche.deleteBienTitle' | translate }}
                                              </h3>
                                              <p>
                                                {{
                                                'logements.fiche.deleteBienBody'
                                                | translate
                                                : {
                                                titre: current.titreDto || ('common.untitled' | translate),
                                                unites: unites.toLowerCase()
                                              }
                                              }}
                                            </p>
                                            @if (bienDeleteError) {
                                              <p class="logements-status logements-status--error">
                                                {{ 'logements.fiche.deleteBienError' | translate }}
                                              </p>
                                            }
                                            <div class="logements-dialog-actions">
                                              <button
                                                type="button"
                                                class="logements-cancel"
                                                [disabled]="isBusy"
                                                (click)="cancelBienDelete()"
                                                >
                                                {{ 'common.cancel' | translate }}
                                              </button>
                                              <button
                                                type="button"
                                                class="logements-action-btn logements-action-btn--danger"
                                                [disabled]="isBusy"
                                                (click)="confirmDeleteBien()"
                                                >
                                                {{
                                                deletingBien
                                                ? ('common.deleting' | translate)
                                                : ('common.delete' | translate)
                                                }}
                                              </button>
                                            </div>
                                          }
                                        </dialog>

                                        <dialog
                                          #uniteDeleteDialog
                                          class="logements-dialog"
                                          aria-labelledby="delete-unite-title"
                                          (cancel)="onUniteDeleteDialogCancel($event)"
                                          (click)="onDialogBackdropClick($event, 'unite')"
                                          (keydown)="onDialogBackdropKeydown($event, 'unite')"
                                          >
                                          @if (unitToDelete; as unite) {
                                            <h3 id="delete-unite-title">
                                              {{ 'logements.fiche.deleteUniteTitle' | translate }}
                                            </h3>
                                            <p>
                                              {{
                                              'logements.fiche.deleteUniteBody'
                                              | translate: { label: label(unite) }
                                              }}
                                              @if (isLastUnite) {
                                                {{ 'logements.fiche.deleteUniteLast' | translate }}
                                              }
                                            </p>
                                            <div class="logements-dialog-actions">
                                              <button
                                                type="button"
                                                class="logements-cancel"
                                                [disabled]="isBusy"
                                                (click)="cancelDelete()"
                                                >
                                                {{ 'common.cancel' | translate }}
                                              </button>
                                              <button
                                                type="button"
                                                class="logements-action-btn logements-action-btn--danger"
                                                [disabled]="isBusy"
                                                (click)="confirmDelete()"
                                                >
                                                {{
                                                deletingId
                                                ? ('common.deleting' | translate)
                                                : ('common.delete' | translate)
                                                }}
                                              </button>
                                            </div>
                                          }
                                        </dialog>

  <ng-template
    #uniteTypeNumeroFields
    let-includeExtraType="includeExtraType"
  >
    <div class="logements-form-row">
      <label [class.is-invalid]="showError('typeUnite')">
        {{ 'logements.fiche.type' | translate }}
        <select formControlName="typeUnite">
          <option value="">{{ 'common.choose' | translate }}</option>
          @if (includeExtraType && extraType) {
            <option [value]="extraType">
              {{ extraType | i18nValue: 'ref.typeUnite' }}
            </option>
          }
          @for (type of typesUnite; track type) {
            <option [value]="type">
              {{ type | i18nValue: 'ref.typeUnite' }}
            </option>
          }
        </select>
        @if (showError('typeUnite')) {
          <span class="logements-field-error">
            {{ errorMessage('typeUnite') }}
          </span>
        }
      </label>
      <label>
        {{ 'logements.fiche.numero' | translate }}
        <span class="logements-optional">{{ 'common.optional' | translate }}</span>
        <input
          type="text"
          formControlName="numero"
          placeholder="A1"
        />
      </label>
    </div>
  </ng-template>

  <ng-template #uniteSurfacePiecesFields>
    <div class="logements-form-row">
      <label [class.is-invalid]="showError('surface')">
        {{ 'logements.fiche.surface' | translate }}
        <span class="logements-optional">{{ 'common.optional' | translate }}</span>
        <input
          type="number"
          min="1"
          step="1"
          formControlName="surface"
        />
        @if (showError('surface')) {
          <span class="logements-field-error">
            {{ errorMessage('surface') }}
          </span>
        }
      </label>
      @if (!isParking) {
        <label [class.is-invalid]="showError('nombrePieces')">
          {{ 'logements.fiche.pieces' | translate }}
          <span class="logements-optional">{{ 'common.optional' | translate }}</span>
          <input
            type="number"
            min="1"
            step="1"
            formControlName="nombrePieces"
          />
          @if (showError('nombrePieces')) {
            <span class="logements-field-error">
              {{ errorMessage('nombrePieces') }}
            </span>
          }
        </label>
      }
    </div>
  </ng-template>
                                      </div>
